import axios from 'utils/axios';

// Role-agnostic per-clinic feature flags for UI gating — any user with access
// to the clinic can read them (unlike the manager-gated clinic-settings
// endpoint). Response: { outboundCallingEnabled, medhxEnabled }.
export async function getClinicFeatures(clinicId) {
    const response = await axios.get(`/api/org-id/{orgId}/clinic-id/${clinicId}/features`);

    return response;
}
